import React from "react";
import {Col, Row} from "react-bootstrap";
import {Election} from "./Election";

type HeaderProps = {
    election: Election
}

const Header = (props:HeaderProps) => {
    return (
        <Row className={"justify-content-center mb-4"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                <img className="img-fluid w-50" src={props.election.configuration.logo_url} alt="Logo"/>

            </Col>
        </Row>
    );
  }

export default Header;
